export default class Link {
  label;
  href;
  to;
  icon;
  value;
  type;
  show = false;

  constructor(data = {}) {
    this.label = data.label;
    this.href = data.href;
    this.to = data.to;
    this.icon = data.icon || '';
    this.value = data.value || false;
    this.type = data.type || 'link';
    this.links = data.links || [];
  }

  get key() {
    return `${this.to}/${this.href}/${this.label}`;
  }

  static link(label, href, icon) {
    return new Link({
      label,
      href,
      icon,
    });
  }

  static group(label, href, icon, links) {
    return new Link({
      type: 'group',
      label,
      href,
      icon,
      links,
    });
  }
}
